class SectionMainLogin extends HTMLElement {
    connectedCallback() {
        this.initEventListeners();
        this.resetPasswordSuccess();
    }

    /**
     * Initialize event listeners for form validation and interactions
     */
    initEventListeners() {
        const recoverLinks = this.querySelectorAll('.RecoverPassword'); // Sửa biến từ recoverLink -> recoverLinks
        const loginForm = this.querySelector('#customer_login');
        const recoverForm = this.querySelector(".recover_password--account form");

        if (recoverLinks.length > 0) {
            recoverLinks.forEach(link => {
                link.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.toggleRecoverPasswordForm();
                });
            });
        }

        if (loginForm) {
            loginForm.addEventListener('submit', (event) => {
                event.preventDefault(); // Always prevent default submission first
                
                const isFormValid = this.validateForm(loginForm);
                console.log("Validation result:", isFormValid);
                
                if (isFormValid) {
                    loginForm.requestSubmit(); // Allow submission only if validation passes
                } else {
                    event.stopImmediatePropagation();
                }
            });
        }

        if (recoverForm) {
            recoverForm.addEventListener('submit', (event) => {
                event.preventDefault(); // Prevent default submission
                
                const isFormValid = this.validateForm(recoverForm);
                
                if (isFormValid) {
                    recoverForm.requestSubmit();
                } else {
                    event.stopImmediatePropagation();
                }
            });
        }
    }

    /**
     * Toggle between login form and password recovery form
     */
    toggleRecoverPasswordForm() {
        const passwordForm = this.querySelector('#recover');
        const loginForm = this.querySelector('#account__form--main');
        
        if (passwordForm && loginForm) {
            console.log("Toggling password recovery form"); // Debug
            passwordForm.classList.toggle('hidden');
            loginForm.classList.toggle('hidden');
        } else {
            console.error("Elements not found: passwordForm or loginForm");
        }
    }

    /**
     * Validate form fields - checks if inputs are empty or invalid
     * @param {HTMLElement} form - The form element to validate
     * @returns {boolean} - Returns true if all inputs are valid, false otherwise
     */
    validateForm(form) {
        const inputs = form.querySelectorAll('.field--box .input__field');
        let isValid = true;

        inputs.forEach(input => {
            const errorElement = form.querySelector(`#entry-${input.id}`);
            let inputValid = true; // Create a separate flag for each input

            if (!input.value.trim()) {
                inputValid = false;
                this.showWithTransition(errorElement);
            } else if (input.type === 'email' && !input.checkValidity()) {
                inputValid = false;
                this.showWithTransition(errorElement);
            } else {
                this.fadeOutError(errorElement);
            }

            if (!inputValid) {
                isValid = false;
            }
        });

        console.log("Final validation result:", isValid);
        return isValid;
    }

    /**
     * Show validation errors with a smooth opacity transition
     * @param {HTMLElement} element - The error message element to show
     */
    showWithTransition(element) {
        if (element) {
            element.classList.remove('hidden');
            element.style.opacity = '0';
            element.style.transition = 'opacity 0.3s ease-in-out';
            setTimeout(() => {
                element.style.opacity = '1';
            }, 10);
        }
    }

    /**
     * Hide validation errors smoothly before re-adding the hidden class
     * @param {HTMLElement} element - The error message element to hide
     */
    fadeOutError(element) {
        if (element) {
            element.style.transition = 'opacity 0.3s ease-in-out';
            element.style.opacity = '0';
            setTimeout(() => {
                element.classList.add('hidden');
            }, 300);
        }
    }

    /**
     * Show success message when password reset is successful
     */
    resetPasswordSuccess() {
        const formState = this.querySelector('.reset-password-success');
        if (formState) {
            const resetSuccessMessage = this.querySelector('#ResetSuccess');
            if (resetSuccessMessage) {
                resetSuccessMessage.classList.remove('hide');
            }
        }
    }
}

customElements.define('main-login', SectionMainLogin);
